import { CurrencyPipe, DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';

import { environment } from '@app/env-service';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class WarehouseScanService {
  url :string = environment.url;

  curPipe :CurrencyPipe;
  datePipe :DatePipe;

  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  loading$ = this._loading.asObservable();

  constructor(private http :HttpClient) {
    this.curPipe = new CurrencyPipe('en');
    this.datePipe = new DatePipe('en');
  }

  get(params) {
    return this.http.get(`${this.url}/inventory`, { params: params });
  }
  getScannerData(scannedValue :string) :Observable<any> {
    const url = `${this.url}/scanner?scanned_value=${scannedValue}`;

    return this.http.get(url);
  }
}
